<template>
  <div>
    <div class="information_title">配套设施</div>
    <!-- 配套设施 -->
    <div v-for="(item, index) in hourseList" :key="index">
      <div class="bathroom" v-if="item.iConfigStatus == 1">
        <div class="bathroom_left">{{ item.vMenuName }}：</div>
        <div class="bathroom_right">
          <div
            class="checkbox_Box"
            v-for="(item2, i) in item.children"
            :key="i"
          >
            <el-checkbox-group v-model="from.houseConfig.vConfigIds">
              <el-checkbox :label="item2.iConfigId">{{
                item2.vMenuName
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="information_title">入住须知</div>
    <div class="notice_Box">
      <div
        class="notice"
        v-for="(item_s, index) in CheckInNotesList"
        :key="'item_s' + index"
      >
        <div class="notice_left">{{ item_s.vMenuName }}：</div>
        <div class="notice_right">
          <div>
            <el-checkbox-group v-model="from.houseConfig.vConfigIds">
              <el-checkbox
                :label="item_s.iConfigId"
                class="label"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      class="radio_bottom"
      v-for="(item3, index3) in CheckInNotesList"
      :key="'item3-' + index3"
    >
      <div class="radio_bottom_text">{{ item3.label }}：</div>
      <div class="radio_yes" @click="CheckInNotesBtn(item, index)">
        <div class="radio_yes_left_s">
          <div class="radio_box"></div>
        </div>
        <div class="radio_yes_left"></div>
        <div class="radio_yes_right">是</div>
      </div>
      <div class="radio_no" @click="BtnZero(item, index)">
        <div class="radio_no_left_s">
          <div class="radio_box"></div>
        </div>
        <div class="radio_no_left"></div>
        <div class="radio_no_right">否</div>
      </div>
    </div> -->

    <div class="attention_title">
      <div class="attention_title_left">其他注意事项</div>
      <div class="attention_title_right">补充需要客人遵守的其他注意事项</div>
    </div>
    <div class="attention">
      <el-input
        type="textarea"
        maxlength="1000"
        resize="none"
        show-word-limit
        placeholder="请输入内容"
        v-model="from.houseInfoSon.vOtherName"
      >
      </el-input>
    </div>
    <div class="next_Btn" @click="next_Btn">
      <el-button>保存并继续<i class="el-icon-arrow-right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { hourseInfo, houseConfigList, publishThreeAjax } from "../../api/index";
export default {
  props: ["isStatus"],
  data() {
    return {
      Status: "",
      active: 4,
      CheckInNotesList: [],
      hourseList: [],
      houseId: window.sessionStorage.getItem("hourId").toString() || "",
      from: {
        houseId: window.sessionStorage.getItem("hourId") || "",
        houseConfig: { vConfigIds: [] },
        houseInfoSon: { vOtherName: "" }
      }
    };
  },
  // watch: {
  //   CheckInNotes: {
  //     deep: true, //如果不写就是浅监控，只能监视普通变量。如果是对象的的属性变化就监视不到
  //     handler(newVal, oldVal) {
  //       this.CheckInNotes = newVal;
  //     }
  //   }
  // },
  created() {
      this.$nextTick(()=>{
          document.querySelector(".el-main").scrollTop = 0;
      })
      this.houseConfigListAjax();
    this.Status = this.isStatus;
    if (this.Status == 1) this.hourseInfoAjax();
  },
  methods: {
    // 获取列表数据
    async hourseInfoAjax() {
      const { data: res } = await hourseInfo(this.houseId);
      this.from.houseConfig.vConfigIds =
        res.data.hourseInfo.houseConfig.vConfigId.split(",").map(Number) || [];
      this.from.houseInfoSon.vOtherName =
        res.data.hourseInfo.houseInfoSon.vOtherName || "";
    },
    async houseConfigListAjax() {
      const { data: res } = await houseConfigList();
      this.CheckInNotesList = res.data.checkNotice[0].children;
      this.hourseList = res.data.houseHold;
    },
    async next_Btn() {
      const { data: res } = await publishThreeAjax(this.from);
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.msg
        });
      }
      this.CheckInNotesList = [];
      this.hourseList = [];
      this.houseId = window.sessionStorage.getItem("hourId").toString() || "";
      this.from = {
        houseId: window.sessionStorage.getItem("hourId") || "",
        houseConfig: { vConfigIds: [] },
        houseInfoSon: { vOtherName: "" }
      };
      this.$emit("active", this.active);
      return this.$message({
        type: "success",
        message: res.msg
      });
    }
    // CheckInNotesBtn(item, index) {
    //   this.CheckInNotes[index] = item.value;
    //   console.log(this.CheckInNotes);
    // },
    // BtnZero(index) {
    //   this.CheckInNotes[index] = 0;
    // }
  }
};
</script>
<style lang="less" scoped>
.information_title {
  height: 66px;
  line-height: 66px;
  margin-top: 30px;
  color: #f6b439;
  font-size: 20px;
  border-bottom: 1px solid #e1e1e1;
}
.attention {
  padding-left: 36px;
}
.attention_title {
  height: 66px;
  line-height: 66px;
  margin-top: 30px;

  .attention_title_left {
    float: left;
    color: #f6b439;
    font-size: 20px;
  }
  .attention_title_right {
    float: left;
    margin-left: 10px;
    color: #666666;
  }
}
.next_Btn {
  margin: 90px 0 94px 36px;
  .el-button {
    font-size: 24px;
    color: #fff;
    width: 204px;
    height: 64px;
    background-color: #f6b439;
  }
}
.bathroom {
  overflow: hidden;
  padding: 30px 36px;
  // height: 148px;
  .bathroom_left {
    float: left;
    font-size: 18px;
    color: #000;
    margin-right: 80px;
  }
  .bathroom_right {
    width: 1100px;
    float: left;
  }
}
.checkbox_Box {
  width: 225px;
  height: 64px;
  float: left;
}
/deep/.el-checkbox {
  margin-bottom: 40px;
  margin-right: 150px;
  height: 26px;

  .el-checkbox__inner {
    width: 24px;
    height: 24px;
  }
  .el-checkbox__inner::after {
    width: 8px;
    height: 14px;
    margin-left: 2px;
    color: #f6b439;
    border-right: 2px solid #f6b439;
    border-bottom: 2px solid #f6b439;
  }
  .el-checkbox__inner:hover {
    border-color: #f6b439;
  }
  .el-checkbox__label {
    font-size: 18px;
    color: #333333;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fff;
    border-color: #999999;
  }
}
.radio_bottom {
  margin-top: 30px;
  padding-left: 36px;
  .radio_bottom_text {
    width: 584px;
    height: 34px;
    float: left;
    line-height: 34px;
    font-size: 18px;
  }
  height: 34px;
  .radio_yes {
    cursor: pointer;
    width: 58px;
    line-height: 34px;
    float: left;
    margin-left: 72px;
    .radio_yes_left {
      margin: 5px 15px 0 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #dcdcdc;
      float: left;
    }
    .radio_yes_right {
      float: left;
      font-size: 18px;
    }
  }
  .radio_no {
    width: 58px;
    line-height: 34px;
    float: left;
    margin-left: 100px;
    .radio_no_left {
      margin: 5px 15px 0 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #dcdcdc;
      float: left;
    }
    .radio_no_right {
      float: left;
      font-size: 18px;
    }
  }
}
.radio_yes_left_s {
  margin: 5px 15px 0 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #f6b439;
  float: left;
}
.radio_no_left_s {
  margin: 5px 15px 0 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #f6b439;
  float: left;
}
.radio_box {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 6px;
  background-color: #f6b439;
}
/deep/.el-textarea__inner {
  width: 958px;
  height: 300px;
}
/deep/.el-textarea {
  width: 950px;
}
.notice_Box {
  overflow: hidden;
  padding: 30px 0 0 0;
}
.notice {
  position: relative;
  width: 100%;
  height: 64px;
  float: left;
  .notice_left {
    position: absolute;
    top: 0;
    left: 36px;
    font-size: 18px;
    color: #000;
    margin-right: 80px;
  }
  .notice_right {
    position: absolute;
    top: 0;
    left: 620px;
    float: left;
  }
}
/deep/.label {
  .el-checkbox__label {
    display: none;
  }
}
</style>
